import { SuffixIcon, TagRenderer } from '@med-fe/ui';
import { Button, Form, Input, Row, Select } from 'antd';
import { HooRequestStatusEnum } from 'apps/mod/src/models/hoo-request-status-enum';
import { useDispatch } from 'react-redux';
import { setSearchHoo } from '../../HooAccommodations/actions';

function SeachHooRequests() {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const locStatusTypes = Object.entries(HooRequestStatusEnum).map(([key, label]) => {
    return { label, value: key };
  });

  const onSubmit = (formData) => {
    dispatch(setSearchHoo(formData));
  };

  return (
    <Form
      form={form}
      layout='vertical'
      className='search-container location-search'
      onFinish={onSubmit}
      validateTrigger={['onSubmit']}
      initialValues={{ statuses: ['PENDING'] }}
      style={{ justifyContent: 'space-between' }}
    >
      <div style={{ display: 'flex', alignSelf: 'flex-start', flexDirection: 'column' }}>
        <Row wrap={true}>
          <Form.Item key='statuses' label={'Select Status'} name='statuses' className='label-text status-type'>
            <Select
              allowClear
              mode={'multiple'}
              tagRender={(props) => <TagRenderer {...props} />}
              placeholder='Select Status'
              options={locStatusTypes}
              suffixIcon={<SuffixIcon />}
            />
          </Form.Item>
        </Row>
      </div>
      <div style={{ display: 'flex', marginTop: '10px', alignSelf: 'flex-start' }}>
        <Form.Item className='search-btn'>
          <Input.Group compact style={{ display: 'flex' }}>
            <Button type='primary' htmlType='submit'>
              SEARCH
            </Button>
          </Input.Group>
        </Form.Item>
      </div>
    </Form>
  );
}

export default SeachHooRequests;
